import React from 'react';
import {Box} from '@mui/material';
import {Body, designSystemToken, Icon} from '@lightricks/react-design-system';
import NotificationBanner, {
  NotificationBannerState,
  NotificationContentType,
} from '@contentlab/components/notification-banner';
import {AssetErrors} from '@contentlab/stores/contentLabStore';
import translate from '@/utils/translate';

function UploadContentAssetError({assetErrors}: {assetErrors: AssetErrors[]}) {
  if (!assetErrors.length) {
    return null;
  }

  return (
    <NotificationBanner
      state={NotificationBannerState.ERROR}
      content={{
        type: NotificationContentType.CUSTOM_RENDER,
        customRender: () => (
          <Body
            size="sm"
            color={designSystemToken('semantic.fg.danger')}
            sx={{transform: 'translateY(-2px)'}}
          >
            <strong>
              {translate('Oops!')} {assetErrors.length}{' '}
              {translate("videos can't be edited.")}
            </strong>{' '}
            {translate('Hover the')}
            <Icon
              size="small"
              appearance="danger"
              name="Actions-Info-Line"
              style={{
                paddingInline: '4px',
                transform: 'translateY(2px)',
              }}
            />
            {translate('on the failed file to see the reason why.')}
          </Body>
        ),
      }}
    />
  );
}

export default UploadContentAssetError;
